<template>
  <v-card
    class="dash-card d-flex flex-column justify-center align-center"
    elevation="0"
    color="#F7F7FA"
  >
    <span class="custom-grey-3--text font-weight-semibold text-center">
      {{ title }}
    </span>

    <v-progress-circular
      v-if="loading"
      width="2"
      size="30"
      class="mt-3"
      indeterminate
    ></v-progress-circular>
    <span v-else :class="['value-text', 'mt-3', valueColor]">
      {{ value || 0 }}
    </span>
  </v-card>
</template>

<script>
import displayHelpers from "@/mixins/breakpoints.mixins";
export default {
  name: "DashCard",
  mixins: [displayHelpers],
  props: {
    backgroundColor: {
      type: String,
      required: false,
      default: "base",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    value: {
      type: [String, Number],
      required: true,
      default: 0,
    },
    valueColor: {
      type: [String],
      required: false,
      default: "",
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>
.dash-card {
  border-radius: 16px;
  height: 110px;
}

.value-text {
  font-size: 18px;
  font-weight: 600;
}

.positive-percent {
  color: #572c88;
}

.negative-percent {
  color: #d70200;
}
</style>
